import { getJson, postJson } from '../../util/fetch-json.js';
import type { VideoProvider } from '../provider.js';

export const serverVideo: VideoProvider = {
  start: ({ prospect, slot, prompt, durationSec }) =>
    postJson<{ requestId: string }>('/api/video/start', { key: prospect, slot, prompt, durationSec: durationSec ?? 5 }),
  poll: (requestId) => getJson(`/api/video/status?id=${encodeURIComponent(requestId)}`),
};
